import { cognitiveFunctions } from "../utils/globalConst";
import useWindowDimensions from "../utils/hooks/useWindowDimensions";
import { ClipPathStyled } from "./styledComponents";

import IntuitionPattern from "../svg/layout_dark_pattern-intuition.svg";
import SensingPattern from "../svg/layout_dark_pattern-sensing.svg";
import ThinkingPattern from "../svg/layout_dark_pattern-thinking.svg";
import FeelingPattern from "../svg/layout_dark_pattern-feeling.svg";

import neObjects from "../images/objects-intuition-extraversion.png";
import niObjects from "../images/objects-intuition-introversion.png";
import seObjects from "../images/objects-sensing-extraversion.png";
import siObjects from "../images/objects-sensing-introversion.png";
import teObjects from "../images/objects-thinking-extraversion.png";
import tiObjects from "../images/objects-thinking-introversion.png";
import feObjects from "../images/objects-feeling-extraversion.png";
import fiObjects from "../images/objects-feeling-introversion.png";

const CognitiveBackground = ({ s, config, chartId = "cogfunc-bg" }) => {
  const { width: windowWidth, height: windowHeight } = useWindowDimensions();
  const {
    cogFunc: currCogFunc,
    stackFunc: currStackFunc,
    isExvert: currIsExvert,
  } = s;
  const { cogFuncConfig, stackFuncConfig, xVersionConfig } = config;

  const cogFuncIdx = cogFuncConfig.map((d) => d.cogFunc).indexOf(currCogFunc);
  const stackFuncIdx = stackFuncConfig
    .map((d) => d.stackFunc)
    .indexOf(currStackFunc);

  const funcIdx = cognitiveFunctions
    .map((d) => d.function)
    .indexOf(currCogFunc);

  const {
    style: { quad },
  } = cogFuncConfig[cogFuncIdx];
  const {
    style: { rotation },
  } = stackFuncConfig[stackFuncIdx];
  const {
    style: { innerRadiusRatio },
  } = xVersionConfig[currIsExvert ? 0 : 1];

  const uniqueId = `${chartId}-${currCogFunc}`;
  const cogFuncId = `cogfunc-${uniqueId}`;
  const clipPathId = `clip-path-${uniqueId}`;
  const transformClipPath = `rotate(${rotation})`;
  const transformCogFunc = `scale(${quad[0] ? -1 : 1} ${quad[1] ? -1 : 1})`;

  const isPortrait = windowWidth < windowHeight;

  const patternProps = {
    x: isPortrait ? -(windowHeight / 2 - windowWidth / 2) : 0,
    y: isPortrait ? 0 : -(windowWidth / 2 - windowHeight / 2),
    width: isPortrait ? windowHeight / 2 : windowWidth / 2,
    height: isPortrait ? windowHeight / 2 : windowWidth / 2,
    opacity: 0.5,
  };

  const objsProps = { ...patternProps };

  const patternImg =
    (currCogFunc === "intuition" && IntuitionPattern) ||
    (currCogFunc === "sensing" && SensingPattern) ||
    (currCogFunc === "thinking" && ThinkingPattern) ||
    (currCogFunc === "feeling" && FeelingPattern);

  const objectsEvnImg =
    (currCogFunc === "intuition" && neObjects) ||
    (currCogFunc === "sensing" && seObjects) ||
    (currCogFunc === "thinking" && teObjects) ||
    (currCogFunc === "feeling" && feObjects);

  const objectsIvnImg =
    (currCogFunc === "intuition" && niObjects) ||
    (currCogFunc === "sensing" && siObjects) ||
    (currCogFunc === "thinking" && tiObjects) ||
    (currCogFunc === "feeling" && fiObjects);

  return (
    <g
      className="cogfunc-background"
      transform={transformCogFunc}
      style={{ transformOrigin: "center" }}
    >
      <ClipPathStyled id={cogFuncId} transform={transformClipPath}>
        <rect
          id={clipPathId}
          y={-(windowWidth * 1.5 - windowHeight / 2)}
          width={windowWidth / 2}
          height={windowWidth * 1.5}
        />
      </ClipPathStyled>
      <g className="graphics-patterns-bgcolor" clipPath={`url(#${cogFuncId})`}>
        <g className="bg-color">
          <rect
            y={-(windowWidth * 1.5 - windowHeight / 2)}
            width={windowWidth / 2}
            height={windowWidth * 1.5}
            fill={cognitiveFunctions[funcIdx].color}
            opacity={0.1}
          ></rect>
        </g>
        <g className="patterns">
          <image
            href={patternImg}
            preserveAspectRatio="xMaxYMid slice"
            {...patternProps}
          />
        </g>
        <g className="graphics">
          <image
            className="objects-extraversion"
            href={objectsEvnImg}
            preserveAspectRatio="xMaxYMid slice"
            style={{
              opacity: 1 - innerRadiusRatio,
            }}
            {...objsProps}
          />
          <image
            className="objects-introversion"
            href={objectsIvnImg}
            preserveAspectRatio="xMaxYMid slice"
            style={{
              opacity: innerRadiusRatio,
            }}
            {...objsProps}
          />
        </g>
      </g>
    </g>
  );
};

export default CognitiveBackground;
